import React, { useState, useEffect } from 'react';
import { CONSENT_KEY, buildAnalyticsUrl, initAnalytics, track, trackPageview } from '../../lib/analytics';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === null) setShow(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'granted');
    setShow(false);
    initAnalytics();
    trackPageview(buildAnalyticsUrl(window.location.href), { consent_entry: 'banner' });
    track('Consent:Granted', { source: 'banner' });
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'denied');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 bg-white border-t border-gray-200 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] mb-safe" data-analytics-area="consent-banner">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600">
              <SafeIcon icon={FiIcons.FiPieChart} className="text-lg" />
            </div>
            <h3 className="font-bold text-gray-900">Wir schätzen deine Privatsphäre</h3>
          </div>
          <p className="text-sm text-gray-600">
            Wir nutzen Plausible Analytics – ein datenschutzfreundliches Tool aus der EU – um anonym zu verstehen,
            wie SchleiShare genutzt wird. Es werden dabei <strong>keine</strong> Tracking-Cookies für Werbung gesetzt.
            Bitte hilf uns, die Plattform zu verbessern, indem du dem Tracking zustimmst.
          </p>
        </div>
        <div className="flex items-center gap-3 w-full md:w-auto mt-2 md:mt-0 shrink-0">
          <button
            type="button"
            onClick={handleDecline}
            data-analytics-label="Analytics ablehnen"
            className="flex-1 md:flex-none px-6 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-bold hover:bg-gray-50 transition-colors text-sm"
          >
            Ablehnen
          </button>
          <button
            type="button"
            onClick={handleAccept}
            data-analytics-label="Analytics akzeptieren"
            className="flex-1 md:flex-none px-6 py-2.5 rounded-xl bg-purple-600 text-white font-bold hover:bg-purple-700 transition-colors shadow-sm text-sm"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
